module.exports = __webpack_public_path__ + "assets/src/style/img/svg/icons/category-this-week.svg?51545b777600c7aff600c0621ae413ed";